import { useEffect, useState } from 'react';

/**
 * De host waarin VTS draait, als die erom vraagt: de webbridge zet dan data-host op <html> (bericht 'theme', veld host).
 * Zonder host is het null, en ziet VTS eruit zoals altijd. In host-modus toont VTS sommige dingen compacter, omdat de
 * host ze al toont of omdat er minder ruimte is, zoals de kosten achter een knop in plaats van een regel.
 */
export function useHostModus(): string | null {
  const [host, setHost] = useState<string | null>(() => document.documentElement.getAttribute('data-host'));
  useEffect(() => {
    const root = document.documentElement;
    const lees = () => setHost(root.getAttribute('data-host'));
    const mo = new MutationObserver(lees);
    mo.observe(root, { attributes: true, attributeFilter: ['data-host'] });
    lees();
    return () => mo.disconnect();
  }, []);
  return host;
}
